import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout";
import "./EventDeleteForm.css";

const EventDeleteForm = () => {
  const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState("");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/events/upcoming`
        );
        if (response.ok) {
          const data = await response.json();
          setEvents(data);
        } else {
          toast.error("Fehler beim Abrufen der Events.");
        }
      } catch (error) {
        toast.error("Fehler beim Abrufen der Events.");
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  const handleEventChange = (e) => {
    setSelectedEventId(e.target.value);
  };

  const handleDeleteEvent = async () => {
    if (!selectedEventId) {
      toast.info("Bitte wählen Sie ein Event aus.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/events/${selectedEventId}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        toast.success("Event erfolgreich gelöscht.");
        setEvents(events.filter((event) => event.id !== selectedEventId));
        setSelectedEventId("");
      } else {
        toast.error("Fehler beim Löschen des Events.");
      }
    } catch (error) {
      toast.error("Fehler beim Löschen des Events.");
      console.error("Error deleting event:", error);
    }
  };

  return (
    <Layout>
      <div className="Top">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          closeOnClick
          pauseOnHover
        />
        <div className="delete-event-card">
          <h2 className="delete-event-title">Event Löschen</h2>
          <div className="delete-event-select">
            <label>
              <select
                value={selectedEventId}
                onChange={handleEventChange}
                className="event-select-dropdown"
              >
                <option value="">-- Wähle ein Event aus --</option>
                {events.map((event) => (
                  <option key={event.id} value={event.id}>
                    {event.name} -{" "}
                    {new Date(event.event_date).toLocaleDateString()}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <button onClick={handleDeleteEvent} className="delete-event-button">
            Event löschen
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default EventDeleteForm;
